export const getPyodideLoader = () => {
    globalThis.pyodide = {};
    globalThis.loadPyodide = async function (config = {}) {
        if (globalThis.__pyodideLoading) {
            if (globalThis.languagePluginURL) {
                throw new Error("Pyodide is already loading because languagePluginURL is defined.");
            }
            else {
                throw new Error("Pyodide is already loading.");
            }
        }
        globalThis.__pyodideLoading = true;
        let Module = {};
        let baseURL = config.indexURL || "./";
        if (baseURL.endsWith(".js")) {
            baseURL = baseURL.substr(0, baseURL.lastIndexOf("/"));
        }
        if (!baseURL.endsWith("/")) {
            baseURL += "/";
        }
        const DEFAULT_CHANNEL = "default channel";
        const package_uri_regexp = /^.*?([^\/]*)\.js$/;
        function _uri_to_package_name(package_uri) {
            let match = package_uri_regexp.exec(package_uri);
            if (match) {
                return match[1];
            }
        }
        let loadScript;
        if (self.document) {
            loadScript = (url) => new Promise((res, rej) => {
                const script = self.document.createElement("script");
                script.src = url;
                script.onload = res;
                script.onerror = rej;
                self.document.head.appendChild(script);
            });
        }
        else if (self.importScripts) {
            loadScript = async (url) => {
                self.importScripts(url);
            };
        }
        else {
            throw new Error("Cannot determine runtime environment");
        }
        function recursiveDependencies(names, _messageCallback, errorCallback, sharedLibsOnly) {
            const packages = Module.packages.dependencies;
            const loadedPackages = Module.loadedPackages;
            const sharedLibraries = Module.packages.shared_library;
            const toLoad = new Map();
            const addPackage = (pkg) => {
                if (toLoad.has(pkg)) {
                    return;
                }
                toLoad.set(pkg, DEFAULT_CHANNEL);
                if (loadedPackages[pkg] !== undefined) {
                    return;
                }
                for (let dep of packages[pkg]) {
                    addPackage(dep);
                }
            };
            for (let name of names) {
                const pkgname = _uri_to_package_name(name);
                if (pkgname !== undefined) {
                    if (toLoad.has(pkgname) && toLoad.get(pkgname) !== name) {
                        errorCallback(`Loading same package ${pkgname} from ${name} and ${toLoad.get(pkgname)}`);
                        continue;
                    }
                    toLoad.set(pkgname, name);
                }
                else if (name in packages) {
                    addPackage(name);
                }
                else {
                    errorCallback(`Skipping unknown package '${name}'`);
                }
            }
            if (sharedLibsOnly) {
                let onlySharedLibs = new Map();
                for (let c of toLoad) {
                    if (c[0] in sharedLibraries) {
                        onlySharedLibs.set(c[0], toLoad.get(c[0]));
                    }
                }
                return onlySharedLibs;
            }
            return toLoad;
        }
        async function _loadPackage(names, messageCallback, errorCallback) {
            let toLoad = recursiveDependencies(names, messageCallback, errorCallback);
            Module.locateFile = (path) => {
                let pkg = path.replace(/\.data$/, "");
                if (toLoad.has(pkg)) {
                    let package_uri = toLoad.get(pkg);
                    if (package_uri != DEFAULT_CHANNEL) {
                        return package_uri.replace(/\.js$/, ".data");
                    }
                }
                return baseURL + path;
            };
            if (toLoad.size === 0) {
                return Promise.resolve("No new packages to load");
            }
            else {
                let packageNames = Array.from(toLoad.keys()).join(", ");
                messageCallback(`Loading ${packageNames}`);
            }
            let windowErrorHandler;
            let windowErrorPromise;
            if (self.document) {
                windowErrorPromise = new Promise((_res, rej) => {
                    windowErrorHandler = (e) => {
                        errorCallback("Unhandled error. We don't know what it is or whether it is related to 'loadPackage' but out of an abundance of caution we will assume that loading failed.");
                        errorCallback(e);
                        rej(e.message);
                    };
                    self.addEventListener("error", windowErrorHandler);
                });
            }
            else {
                windowErrorPromise = new Promise(() => { });
            }
            let scriptPromises = [];
            for (let [pkg, uri] of toLoad) {
                let loaded = Module.loadedPackages[pkg];
                if (loaded !== undefined) {
                    if (loaded === uri || uri === DEFAULT_CHANNEL) {
                        messageCallback(`${pkg} already loaded from ${loaded}`);
                        continue;
                    }
                    else {
                        errorCallback(`URI mismatch, attempting to load package ${pkg} from ${uri} ` +
                            `while it is already loaded from ${loaded}. To override a dependency, ` +
                            `load the custom package first.`);
                        continue;
                    }
                }
                let scriptSrc = uri === DEFAULT_CHANNEL ? `${baseURL}${pkg}.js` : uri;
                messageCallback(`Loading ${pkg} from ${scriptSrc}`);
                scriptPromises.push(loadScript(scriptSrc).catch(() => {
                    errorCallback(`Couldn't load package from URL ${scriptSrc}`);
                    toLoad.delete(pkg);
                }));
            }
            function waitRunDependency() {
                const promise = new Promise((r) => {
                    Module.monitorRunDependencies = (n) => {
                        if (n === 0) {
                            r();
                        }
                    };
                });
                Module.addRunDependency("dummy");
                Module.removeRunDependency("dummy");
                return promise;
            }
            let successPromise = Promise.all(scriptPromises).then(waitRunDependency);
            try {
                await Promise.race([successPromise, windowErrorPromise]);
            }
            finally {
                delete Module.monitorRunDependencies;
                if (windowErrorHandler) {
                    self.removeEventListener("error", windowErrorHandler);
                }
            }
            let packageList = [];
            for (let [pkg, uri] of toLoad) {
                Module.loadedPackages[pkg] = uri;
                packageList.push(pkg);
            }
            let resolveMsg;
            if (packageList.length > 0) {
                let packageNames = packageList.join(", ");
                resolveMsg = `Loaded ${packageNames}`;
            }
            else {
                resolveMsg = "No packages loaded";
            }
            Module.reportUndefinedSymbols();
            messageCallback(resolveMsg);
            Module.runPythonSimple("import importlib\n" + "importlib.invalidate_caches()\n");
        }
        let loadPackageChain = Promise.resolve();
        Module.loadedPackages = {};
        Module.loadPackage = async function (names, messageCallback, errorCallback) {
            if (Module.isPyProxy(names)) {
                let temp;
                try {
                    temp = names.toJs();
                }
                finally {
                    names.destroy();
                }
                names = temp;
            }
            if (!Array.isArray(names)) {
                names = [names];
            }
            let sharedLibraryNames = [];
            try {
                let sharedLibraryPackagesToLoad = recursiveDependencies(names, messageCallback, errorCallback, true);
                for (let pkg of sharedLibraryPackagesToLoad) {
                    sharedLibraryNames.push(pkg[0]);
                }
            }
            catch (e) {
            }
            let oldPlugin;
            for (let p in Module.preloadPlugins) {
                if (Module.preloadPlugins[p].canHandle("test.so")) {
                    oldPlugin = Module.preloadPlugins[p];
                    break;
                }
            }
            let dynamicLoadHandler = {
                get: function (obj, prop) {
                    if (prop === "handle") {
                        return function (bytes, name) {
                            obj[prop].apply(obj, arguments);
                            this["asyncWasmLoadPromise"] = this["asyncWasmLoadPromise"].then(function () {
                                Module.loadDynamicLibrary(name, {
                                    global: true,
                                    nodelete: true,
                                });
                            });
                        };
                    }
                    else {
                        return obj[prop];
                    }
                },
            };
            var loadPluginOverride = new Proxy(oldPlugin, dynamicLoadHandler);
            Module.preloadPlugins.unshift(loadPluginOverride);
            let promise = loadPackageChain.then(() => _loadPackage(sharedLibraryNames, messageCallback || console.log, errorCallback || console.error));
            loadPackageChain = loadPackageChain.then(() => promise.catch(() => { }));
            await promise;
            Module.preloadPlugins.shift(loadPluginOverride);
            promise = loadPackageChain.then(() => _loadPackage(names, messageCallback || console.log, errorCallback || console.error));
            loadPackageChain = loadPackageChain.then(() => promise.catch(() => { }));
            await promise;
        };
        function fixRecursionLimit(pyodide) {
            let depth = 0;
            function recurse() {
                depth += 1;
                recurse();
            }
            try {
                recurse();
            }
            catch (err) { }
            let recursionLimit = depth / 50;
            if (recursionLimit > 1000) {
                recursionLimit = 1000;
            }
            pyodide.runPythonSimple(`import sys; sys.setrecursionlimit(int(${recursionLimit}))`);
        }
        let PUBLIC_API = [
            "globals",
            "pyodide_py",
            "version",
            "loadPackage",
            "loadPackagesFromImports",
            "loadedPackages",
            "isPyProxy",
            "pyimport",
            "runPython",
            "runPythonAsync",
            "registerJsModule",
            "unregisterJsModule",
            "setInterruptBuffer",
            "toPy",
            "PythonError",
        ];
        function makePublicAPI(module, public_api) {
            let namespace = { _module: module };
            module.public_api = namespace;
            for (let name of public_api) {
                namespace[name] = module[name];
            }
            return namespace;
        }
        Module.noImageDecoding = true;
        Module.noAudioDecoding = true;
        Module.noWasmDecoding = false;
        Module.preloadedWasm = {};
        let fatal_error_occurred = false;
        Module.fatal_error = function (e) {
            if (fatal_error_occurred) {
                console.error("Recursive call to fatal_error. Inner error was:");
                console.error(e);
                return;
            }
            fatal_error_occurred = true;
            console.error("Pyodide has suffered a fatal error. " +
                "Please report this to the Pyodide maintainers.");
            console.error("The cause of the fatal error was:");
            console.error(e);
            try {
                let fd_stdout = 1;
                Module.__Py_DumpTraceback(fd_stdout, Module._PyGILState_GetThisThreadState());
                for (let key of PUBLIC_API) {
                    if (key === "version") {
                        continue;
                    }
                    Object.defineProperty(Module.public_api, key, {
                        enumerable: true,
                        configurable: true,
                        get: () => {
                            throw new Error("Pyodide already fatally failed and can no longer be used.");
                        },
                    });
                }
                if (Module.on_fatal) {
                    Module.on_fatal(e);
                }
            }
            catch (e) {
                console.error("Another error occurred while handling the fatal error:");
                console.error(e);
            }
            throw e;
        };
        Module.pyodide_py = {};
        Module.globals = {};
        Module.PythonError = class PythonError {
            constructor() {
                this.message;
            }
        };
        Module.version = "";
        Module.runPythonSimple = function (code) {
            let code_c_string = Module.stringToNewUTF8(code);
            let errcode;
            try {
                errcode = Module._run_python_simple_inner(code_c_string);
            }
            catch (e) {
                Module.fatal_error(e);
            }
            finally {
                Module._free(code_c_string);
            }
            if (errcode === -1) {
                Module._pythonexc2js();
            }
        };
        Module.runPython = function (code, globals = Module.globals) {
            return Module.pyodide_py.eval_code(code, globals);
        };
        Module.loadPackagesFromImports = async function (code, messageCallback, errorCallback) {
            let imports = Module.pyodide_py.find_imports(code).toJs();
            if (imports.length === 0) {
                return;
            }
            let packageNames = Module.packages.import_name_to_package_name;
            let packages = new Set();
            for (let name of imports) {
                if (name in packageNames) {
                    packages.add(packageNames[name]);
                }
            }
            if (packages.size) {
                await Module.loadPackage(Array.from(packages.keys()), messageCallback, errorCallback);
            }
        };
        Module.pyimport = (name) => {
            console.warn("Access to the Python global namespace via pyodide.pyimport is deprecated and " +
                "will be removed in version 0.18.0. Use pyodide.globals.get('key') instead.");
            return Module.globals.get(name);
        };
        Module.runPythonAsync = async function (code, messageCallback, errorCallback) {
            await Module.loadPackagesFromImports(code, messageCallback, errorCallback);
            let coroutine = Module.pyodide_py.eval_code_async(code, Module.globals);
            try {
                let result = await coroutine;
                return result;
            }
            finally {
                coroutine.destroy();
            }
        };
        Module.registerJsModule = function (name, module) {
            Module.pyodide_py.register_js_module(name, module);
        };
        Module.unregisterJsModule = function (name) {
            Module.pyodide_py.unregister_js_module(name);
        };
        Module.toPy = function (obj, depth = -1) {
            switch (typeof obj) {
                case "string":
                case "number":
                case "boolean":
                case "bigint":
                case "undefined":
                    return obj;
            }
            if (!obj || Module.isPyProxy(obj)) {
                return obj;
            }
            let obj_id = 0;
            let py_result = 0;
            let result = 0;
            try {
                obj_id = Module.hiwire.new_value(obj);
                py_result = Module.__js2python_convert(obj_id, new Map(), depth);
                if (py_result === 0) {
                    Module._pythonexc2js();
                }
                if (Module._JsProxy_Check(py_result)) {
                    return obj;
                }
                result = Module._python2js(py_result);
                if (result === 0) {
                    Module._pythonexc2js();
                }
            }
            finally {
                Module.hiwire.decref(obj_id);
                Module._Py_DecRef(py_result);
            }
            return Module.hiwire.pop_value(result);
        };
        Module.isPyProxy = function (jsobj) {
            return !!jsobj && jsobj.$$ !== undefined && jsobj.$$.type === "PyProxy";
        };
        Module.locateFile = (path) => baseURL + path;
        let moduleLoaded = new Promise((r) => (Module.postRun = r));
        const scriptSrc = `${baseURL}pyodide.asm.js`;
        await loadScript(scriptSrc);
        await _createPyodideModule(Module);
        await moduleLoaded;
        Module.runPythonSimple(`
def temp(Module):
  import pyodide
  import __main__
  import builtins

  globals = __main__.__dict__
  globals.update(builtins.__dict__)

  Module.version = pyodide.__version__
  Module.globals = globals
  Module.builtins = builtins.__dict__
  Module.pyodide_py = pyodide
    `);
        Module.saveState = () => Module.pyodide_py._state.save_state();
        Module.restoreState = (state) => Module.pyodide_py._state.restore_state(state);
        Module.init_dict.get("temp")(Module);
        Module.globals = Module.wrapNamespace(Module.globals);
        let response = await fetch(`${baseURL}packages.json`);
        Module.packages = await response.json();
        fixRecursionLimit(Module);
        let pyodide = makePublicAPI(Module, PUBLIC_API);
        Module.registerJsModule("js", globalThis);
        Module.registerJsModule("pyodide_js", pyodide);
        globalThis.pyodide = pyodide;
        return pyodide;
    };
    if (globalThis.languagePluginUrl) {
        console.warn("languagePluginUrl is deprecated and will be removed in version 0.18.0, " +
            "instead use loadPyodide({ indexURL : <some_url>})");
        globalThis.languagePluginUrl;
        globalThis.languagePluginLoader = loadPyodide({
            indexURL: globalThis.languagePluginUrl,
        });
    }
};
//# sourceMappingURL=pyodide.js.map